<template>
    <div class="admin-page" >
        <h2>Admin sidan</h2>
        <DataCollection v-if="admin.dataCollection.view" />
        <AdminSettings v-if="admin.settings.view" />
    </div>
</template>

<script>
import DataCollection from './components/DataCollection';
import AdminSettings from './components/AdminSettings';
import { mapActions, mapGetters } from 'vuex';
export default {
    name:'AdminHome',
    components: {DataCollection,AdminSettings},
    computed: {
        ...mapGetters(['user','admin'])
    },
}
</script>

<style>

</style>